import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import AutoGrowTextarea from "@/components/AutoGrowTextarea";
import ItemMasterPicker from "./ItemMasterPicker";
import { rupee, r2 } from "@/lib/format";

export default function InvoiceItemRow({ it, idx, canRemove, onChange, onRemove, onPick }) {
  const amount = r2(Number(it.qty || 0) * Number(it.unit_price || 0));
  return (
    <div className="border border-[#E2E8F0] rounded-md px-2 py-2 bg-white min-w-[640px]" data-testid={`invoice-item-${idx}`}>
      <div className="flex items-center gap-1.5">
        <span className="w-5 shrink-0 text-center text-[11px] font-mono text-[#94A3B8]">{idx + 1}</span>
        <Input value={it.item_name} onChange={(e) => onChange({ item_name: e.target.value })}
          placeholder="Description of goods" className="h-8 text-sm flex-1 min-w-[160px]" data-testid={`invoice-item-name-${idx}`} />
        <ItemMasterPicker testId={`invoice-item-master-${idx}`} onPick={onPick} />
        <Input value={it.hsn} onChange={(e) => onChange({ hsn: e.target.value })} className="h-8 w-20 font-mono text-xs" placeholder="HSN" data-testid={`invoice-item-hsn-${idx}`} />
        <Input type="number" min="0" value={it.qty} onChange={(e) => onChange({ qty: e.target.value })} className="h-8 w-14 text-center px-1" placeholder="Qty" data-testid={`invoice-item-qty-${idx}`} />
        <Input value={it.unit} onChange={(e) => onChange({ unit: e.target.value })} className="h-8 w-14 text-center px-1" placeholder="Unit" data-testid={`invoice-item-unit-${idx}`} />
        <Input type="number" min="0" value={it.unit_price} onChange={(e) => onChange({ unit_price: e.target.value })} className="h-8 w-24 text-right font-mono" placeholder="Rate" data-testid={`invoice-item-price-${idx}`} />
        <div className="w-24 shrink-0 text-right font-mono text-sm font-semibold" data-testid={`invoice-item-amount-${idx}`}>{rupee(amount)}</div>
        {canRemove ? (
          <Button type="button" variant="ghost" size="icon" onClick={onRemove} className="h-8 w-8 shrink-0" data-testid={`invoice-item-remove-${idx}`}>
            <X className="w-4 h-4 text-[#EF4444]" />
          </Button>
        ) : <span className="w-8 shrink-0" />}
      </div>
      <div className="flex items-center gap-1.5 mt-1 pl-6">
        <AutoGrowTextarea value={it.description} onChange={(e) => onChange({ description: e.target.value })}
          placeholder="Description / specs (optional)" className="w-full max-w-3xl text-xs py-1" data-testid={`invoice-item-desc-${idx}`} />
      </div>
    </div>
  );
}
